import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import './RegistrationForm.css';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

const RegistrationForm = ({ closeForm, training }) => {
    const [step, setStep] = useState(1);
    const [isClosing, setIsClosing] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        email: '',
        phone: '',
        paymentMethod: '',
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const validateInputs = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.lastname.trim()) newErrors.lastname = 'Last name is required';
        if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Valid email is required';
        if (!formData.phone.trim() || !/^\d{9,15}$/.test(formData.phone)) newErrors.phone = 'Valid phone number is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleNext = () => {
        if (validateInputs()) {
            setIsAnimating(true);
            setTimeout(() => {
                if (step === 2) {
                    navigate('/payment', { state: { training, formData } });
                } else {
                    setStep(step + 1);
                }
                setIsAnimating(false);
            }, 300); // Match the duration of the animation
        }
    };

    const handleBack = () => {
        setIsAnimating(true);
        setTimeout(() => {
            setStep(step - 1);
            setIsAnimating(false);
        }, 300); // Match the duration of the animation
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            closeForm();
        }, 300); // Match the duration of the fadeOut animation
    };

    const handleSelectPaymentMethod = (method) => {
        setFormData((prevData) => ({
            ...prevData,
            paymentMethod: method,
        }));
    };

    return (
        <div className={`form-popup ${isClosing ? 'closing' : ''}`}>
            <div className={`form-container ${isClosing ? 'closing' : ''}`}>
                <div className="progress-bar">
                    <div className="progress" style={{ width: `${(step / 3) * 100}%` }}></div>
                    <div className="steps">
                        <div className={`step ${step >= 1 ? 'active' : ''}`}>1</div>
                        <div className={`step ${step >= 2 ? 'active' : ''}`}>2</div>
                        <div className={`step ${step >= 3 ? 'active' : ''}`}>3</div>
                    </div>
                </div>
                <div className={`form-content ${isAnimating ? 'animating' : ''}`}>
                    {step === 1 ? (
                        <StepOne
                            training={training}
                            formData={formData}
                            handleChange={handleChange}
                            errors={errors} // Pass errors to StepOne
                            handleNext={handleNext}
                        />
                    ) : (
                        <StepTwo
                            formData={formData}
                            handleSelectPaymentMethod={handleSelectPaymentMethod}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        />
                    )}
                </div>
                <button className="close-btn" onClick={handleClose}>Close</button>
            </div>
        </div>
    );
};

export default RegistrationForm;
